import CustomerExecutiveDashboard from "./pages/adm/dashboard/CustomerExecutiveDashboard";
import { Navigate, useRoutes } from "react-router-dom";
import { useState, useEffect } from "react";
// layouts
import DashboardLayout from "./layouts/dashboard";

// Dashboard and Error Page
import NotFound from "./pages/Page404";
import DashboardApp from "./pages/DashboardApp";
import LogoOnlyLayout from "./layouts/LogoOnlyLayout";

// Auth
import Login from "./pages/auth/login/pages/Login";
import ResetPasswordForm from "./pages/auth/reset-password/pages/ResetPassword";
import RequestPassword from "./pages/auth/request-password/pages/RequestPassword";

// ADM Pages
import Tags from "./pages/adm/tags/pages/Tags";
import Clients from "./pages/adm/clients/pages/Clients";
import Sellers from "./pages/adm/clients/pages/Sellers";
import Products from "./pages/adm/products/pages/Products";
import NewClient from "./pages/adm/clients/pages/NewClient";
import NewSeller from "./pages/adm/clients/pages/NewSeller";
import Financial from "./pages/adm/financial/pages/Financial";

// OPERATIONAL Pages
import OperationalOrders from "./pages/operational/pages/Orders";
import OperationalNewOrder from "./pages/operational/pages/NewOrder";
import OperationalReport from "./pages/operational/pages/OperationalReport";
import AdvancedOrderFilters from "./pages/operational/pages/AdvancedOrderFilters";

// CUSTOMER Pages
import Orders from "./pages/customer/pages/Orders";
import Profile from "./pages/customer/pages/Profile";
import NewOrder from "./pages/customer/pages/NewOrder";

//===============================================================================
import http from "./services/http-common";
import Administration from "./pages/adm/administrative/pages/Administration";
import Groups from "./pages/adm/group/pages/Groups";
import NewGroup from "./pages/adm/group/pages/NewGroup";
import Report from "./pages/customer/pages/Report";

import jwt_decode from "jwt-decode";
import Maintenance from "./pages/Maintenance";
import ReportFinancial from "./pages/adm/financial/pages/ReportFinancial";
import ReportAdmin from "./pages/adm/financial/pages/ReportAdmin";
import RankingAR from "./pages/adm/financial/pages/RankingAR";
import CustomerCompare from "./pages/adm/dashboard/CustomerCompare";
import ReportPrePaid from "./pages/customer/pages/ReportPrePaid";
import Courtesy from "./pages/adm/courtesy/pages/Courtesy";
import CourtesyClient from "./pages/customer/pages/Courtesy";
import AuthGuard from "./utils/AuthGuard";
import MainGuard from "./utils/MainGuard";
import RoleGuard from "./utils/RoleGuard";

export default function Router() {
  const parse: any = localStorage.getItem("user");
  const user = JSON.parse(parse);
  const maintenance = false;
  return useRoutes(
    !maintenance
      ? [
          {
            path: "/dashboard",
            element: (
              <AuthGuard>
                <DashboardLayout />
              </AuthGuard>
            ),
            children: [
              { path: "/dashboard", element: <Navigate to="/app" /> },
              { path: "app", element: <DashboardApp /> },
              { path: "clientes", element: <Clients /> },
              { path: "colaboradores", element: <Sellers /> },
              { path: "produtos", element: <Products /> },
              { path: "etiquetas", element: <Tags /> },
              { path: "cortesias", element: <Courtesy /> },
              { path: "clientes/cadastrar", element: <NewClient /> },
              { path: "colaboradores/cadastrar", element: <NewSeller /> },
              { path: "administracao", element: <Administration /> },
              { path: "financeiro", element: <Financial /> },
              //-------------- OPERACIONAL ------------------
              { path: "operacional", element: <OperationalOrders /> },
              { path: "buscar", element: <OperationalNewOrder /> },
              { path: "relatorio-operacional", element: <OperationalReport /> },
              {
                path: "filtros-avancados",
                element: (
                  <RoleGuard roles={["Administrador", "Operacional", "Diretor", "Comercial"]}>
                    <AdvancedOrderFilters />
                  </RoleGuard>
                ),
              },

              { path: "grupos", element: <Groups /> },
              { path: "grupos/cadastrar", element: <NewGroup /> },
              //-------------- CLIENTE ----------------------
              { path: "dados", element: <Profile /> },
              { path: "minhas-cortesias", element: <CourtesyClient /> },
              { path: "pedidos", element: <Orders /> },
              { path: "cadastrar", element: <Orders /> },
              { path: "pedidos/cadastrar", element: <NewOrder /> },
              {
                path: "relatorio",
                element: user?.prepaid ? <ReportPrePaid /> : <Report />,
              },

              { path: "relatorio-admin", element: <ReportAdmin /> },
              { path: "reports", element: <ReportFinancial /> },
              {
                path: "ranking-ar",
                element: (
                  <RoleGuard roles={["Administrador", "Diretor"]}>
                    <RankingAR />
                  </RoleGuard>
                ),
              },
              {
                path: "visao-cliente",
                element: <RoleGuard roles={["Administrador", "Diretor", "Comercial"]}><CustomerExecutiveDashboard /></RoleGuard>,
              },
              {
                path: "comparativo-clientes",
                element: (
                  <RoleGuard roles={["Administrador", "Diretor"]}>
                    <CustomerCompare />
                  </RoleGuard>
                ),
              },
            ],
          },
          {
            path: "/",
            element: (
              <MainGuard>
                <LogoOnlyLayout />
              </MainGuard>
            ),
            children: [
              { path: "/", element: <Navigate to="/entrar" /> },
              { path: "entrar", element: <Login /> },
              { path: "resetar-senha/:token", element: <ResetPasswordForm /> },
              { path: "solicitar-senha", element: <RequestPassword /> },
              { path: "404", element: <NotFound /> },
              { path: "*", element: <Navigate to="/404" /> },
            ],
          },
          {
            path: "*",
            element: maintenance ? (
              <Navigate to="/maintenance" />
            ) : (
              <Navigate to="/404" replace />
            ),
          },
          {
            path: "maintenance",
            element: maintenance ? (
              <Maintenance />
            ) : (
              <Navigate to="/" replace />
            ),
          },
        ]
      : [
          {
            path: "*",
            element: maintenance ? (
              <Maintenance />
            ) : (
              <Navigate to="/" replace />
            ),
          },
        ],
  );
}
